import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import { formatDate } from '../../../utils/format';

const getPreviousStart = (historyItem) => {
  return (
    historyItem?.previousStart ||
    historyItem?.previousDate ||
    historyItem?.previousSchedule ||
    historyItem?.start ||
    historyItem?.scheduledAt ||
    null
  );
};

const buildHistoryKey = (item, index) => {
  if (item?.id) {
    return item.id;
  }

  if (item?.session && item?.createdAt) {
    return `${item.session}-${item.createdAt}`;
  }

  return `history-${index}`;
};

const RescheduleHistory = ({ historyItems }) => {
  if (!historyItems || historyItems.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      {historyItems.map((historyItem, index) => {
        const historyKey = buildHistoryKey(historyItem, index);
        const previousStart = getPreviousStart(historyItem);
        const formattedPreviousStart = previousStart
          ? formatDate(previousStart, 'DD/MM/YYYY HH:mm')
          : 'Fecha no disponible';

        const formattedRescheduledAt = historyItem?.createdAt
          ? formatDate(historyItem.createdAt, 'DD/MM/YYYY HH:mm')
          : null;
        const historyReason =
          historyItem?.reason ||
          historyItem?.description ||
          historyItem?.motiveCancellation ||
          '';

        return (
          <Grid item xs={12} key={historyKey}>
            <Paper elevation={1} style={{ padding: '16px' }}>
              <div className="reschedule-history__item">
                {formattedRescheduledAt && (
                  <p>
                    <strong>Reagendado el:</strong> {formattedRescheduledAt}
                  </p>
                )}
                <p>
                  <strong>Fecha anterior:</strong> {formattedPreviousStart}
                </p>
                <p>
                  <strong>Motivo:</strong>{' '}
                  {historyReason || 'Sin motivo registrado'}
                </p>
                {historyItem?.createdBy?.name && (
                  <p>
                    <strong>Responsable:</strong> {historyItem.createdBy.name}
                  </p>
                )}
              </div>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RescheduleHistory;

